import { render } from "./TimeTableNode.vue?vue&type=template&id=797ce474"
import script from "./TimeTableNode.vue?vue&type=script&lang=ts"
export * from "./TimeTableNode.vue?vue&type=script&lang=ts"
script.render = render

export default script